import _ from 'lodash';
import moment from 'moment';
import api from '@/api';
import router from '@/router';
import * as types from '../mutation-types';

const SESSTION_HISTORY_KEY = 'history';

const state = {
  token: '',
  identity: null,
  expiresTime: null,
  wishlist: [],
  // 第三方收藏夾
  rakuten: [],
  yahoo_jp: [],
  amazon_jp: [],
  shippingAddress: [],
  // 国家/地区数据
  districts: [],
  // 添加/修改收获地址dialog
  shippingAddressDialog: false,
  // 瀏覽記錄
  history: {},
};

const sessionHistory = {
  get() {
    return JSON.parse(sessionStorage.getItem(SESSTION_HISTORY_KEY)) || {};
  },
  save(data) {
    sessionStorage.setItem(SESSTION_HISTORY_KEY, JSON.stringify(data));
  },
  delete() {
    sessionStorage.removeItem(SESSTION_HISTORY_KEY);
  },
};

const getters = {
  isLogined: s => s.token !== '' || s.identity !== null,
  currentUser: s => s.identity,
  hasRole: s => role => s.identity && !!~s.identity.roles.indexOf(role),
  getWishlistCount: s => s.wishlist.length,
  productInWishlist: s => product_id => s.wishlist.length && ~_.findIndex(s.wishlist, { product_id }),
  productInThirdPartyShopWishlist: s => (shop_name, product_id) => (
    s[shop_name].length && ~_.findIndex(s[shop_name], { shop_name, product_id })
  ),
  wishlistCategories: (s) => {
    const categories = [];
    _.each(s.wishlist, (item) => {
      const c = _.find(categories, { id: item.category.id });
      if (c) {
        c.count += 1;
      } else {
        categories.push({ ...item.category, count: 1 });
      }
    });
    return categories;
  },
};

const actions = {
  register({ commit }, params) {
    return api.user.register(params).then(({ data: response }) => {
      commit(types.REVEIVE_IDENTITY, response.data);
    });
  },
  // 在localStorage里读取token信息
  loadTokenFromLocalStore({ commit, dispatch }) {
    const tokenFromLocalStore = localStorage.getItem('token');
    if (tokenFromLocalStore) {
      const token = localStorage.getItem('token');
      const expiresTime = localStorage.getItem('expires-time');
      const expireMs = expiresTime - Date.now();
      // 过时
      if (expireMs <= 0) {
        commit(types.REMOVE_TOKEN);
        return Promise.reject();
      }
      commit(types.SET_TOKEN, token);
      commit(types.SET_EXPIRE_TIME, expiresTime);
      return dispatch('getIdentity');
    }
    return Promise.resolve();
  },
  authenticate({ commit, dispatch }, params) {
    return api.user.authenticate(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  smsAuthenticate({ commit, dispatch }, params) {
    return api.sms.authenticate(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  shipbaoAuthenticate({ commit, dispatch }, params) {
    console.log(111);
    return api.user.shipbaoLogin(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  refreshToken({ commit, dispatch }) {
    return api.user.refresh().then(({ data: response }) => {
      commit(types.RECEIVE_USER_TOKEN, response.token);
    }, (error) => {
      if (error.response.status === 401) {
        return dispatch('logout');
      }
      return Promise.reject(error);
    });
  },
  getIdentity({ commit, state: s, dispatch }) {
    // console.log(s.token);
    return api.user.identity(s.token)
      .then(({ data: response }) => {
        // console.log(response.data);
        commit(types.REVEIVE_IDENTITY, response.data);
        return dispatch('afterLogin');
      }).catch((error) => {
        // console.log(error.response);
        // console.log('getIdentity failed');
        if (!error.response) {
          // token過期
          return dispatch('logout').then(() => {
            router.push({ name: 'login' });
          });
        }
        return error;
        // commit(types.REMOVE_TOKEN);
      });
  },
  /* eslint no-shadow: 0 */
  afterLogin({ dispatch, state }) {
    if (state.identity.status === 2) {
      router.push({ path: '/activation-your-account' });
      return;
    }
    dispatch('saveSessionCart').then(() => {
      setTimeout(() => {
        dispatch('getCart');
      }, 0);
    });
    dispatch('fetchWishlist');
    dispatch('fetchThirdPartyShopWishlist');
    dispatch('saveSessionHistory');
  },
  adminLogin({ commit, dispatch }, params) {
    return api.user.adminLogin(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  logout({ commit }) {
    commit(types.REMOVE_TOKEN);
    commit(types.REVEIVE_IDENTITY, null);
    commit(types.EMPTY_CART);
    commit(types.EMPTY_ORDERS);
    commit(types.EMPRY_HISTORY);
    commit(types.EMPTY_WISHLIST);
    commit(types.EMPTY_SHIPPING_ADDRESS);
  },
  fetchWishlist({ commit }) {
    return api.wishlist.get().then(({ data: response }) => {
      commit(types.RECEIVE_WISHLIST, response.data);
    });
  },
  addToWishlist({ commit }, product) {
    const params = {
      product_id: _.isObject(product) ? product.id : product,
    };
    return api.wishlist.post(params).then(({ data: response }) => {
      commit(types.ADD_TO_WISHLIST, response.data);
    });
  },
  // 用id刪除收藏夾
  removeWishlistItem({ commit }, id) {
    return api.wishlist.delete(id).then((response) => {
      if (response.status === 204) {
        commit(types.REMOVE_WISHLIST_ITEM, id);
      }
    });
  },
  removeWishlist({ commit }, data) {
    _.forEach(data, (item) => {
      api.wishlist.delete(item.id).then((response) => {
        if (response.status === 204) {
          commit(types.REMOVE_WISHLIST_ITEM, item.id);
        }
      });
    });
  },
  removeWishlistItemByProduct({ state: s, dispatch }, product) {
    const item = _.find(s.wishlist, {
      product_id: _.isObject(product) ? product.id : product,
    });
    if (item) {
      return dispatch('removeWishlistItem', item.id);
    }
    return Promise.reject();
  },
  fetchShippingAddress({ commit }) {
    return api.shippingAddress.get().then(({ data: response }) => {
      commit(types.RECEIVE_SHIPPING_ADDRESS, response.data);
    });
  },
  addShippingAddress({ commit }, params) {
    return api.shippingAddress.post(params).then(({ data: response }) => {
      commit(types.ADD_SHIPPING_ADDRESS, response.data);
    });
  },
  editShippingAddress({ commit }, { id, params }) {
    return api.shippingAddress.put(id, params).then(({ data: response }) => {
      commit(types.UPDATE_SHIPPING_ADDRESS, { id, data: response.data });
    });
  },
  deleteShippingAddress({ commit }, id) {
    return api.shippingAddress.delete(id).then((response) => {
      if (response.status === 204) {
        commit(types.DELETE_SHIPPING_ADDRESS, id);
      }
    });
  },
  setDefaultShippingAddress({ commit }, id) {
    return api.shippingAddress.setDefault(id).then(() => {
      commit(types.SET_DEFAULT_SHIPPING_ADDRESS, id);
    });
  },
  fetchDistricts({ commit }) {
    return api.user.districts().then(({ data: response }) => {
      commit(types.RECEIVE_DISTRICTS, response);
    });
  },
  /* eslint-disable */
  addHistory({ commit, rootGetters }, { product_id, shop_name, product_image, product_name }) {
    if (rootGetters.isLogined) {
      return api.history.post({ product_id, shop_name });
    } else {
      const log = {
        product_id,
        shop_name,
        product_image,
        product_name,
        time: ~~(Date.now() / 1000),
      };
      commit(types.NEW_HISTORY, log);
      return Promise.resolve();
    }
  },
  /* eslint-disable */
  fetchHistory({ commit, rootGetters }) {
    if (rootGetters.isLogined) {
      return api.history.get().then(({ data: response }) => {
        commit(types.RECEIVE_HISTORY, response);
      });
    } else {
      const history = sessionHistory.get();
      commit(types.RECEIVE_HISTORY, history);
      return Promise.resolve();
    }
  },
  saveSessionHistory() {
    const history = sessionHistory.get();
    // if (history.length) {
    //   _.forEach(history, (item) => {
    //     api.history.post(item);
    //   });
    //   sessionHistory.delete();
    // }
  },
  fetchThirdPartyShopWishlist({ commit }) {
    return api.thirdPartyShopWishlist.get().then(({ data: response }) => {
      commit(types.RECEIVE_THIRD_PARTY_SHOP_WISHLIST, response.data);
    });
  },
  addToThirdPartyShopWishlist({ commit }, params) {
    return api.thirdPartyShopWishlist.post(params).then(({ data: response }) => {
      commit(types.ADD_TO_THIRD_PARTY_WISHLIST, response.data);
    });
  },
  removeThirdPartyShopWishlist({ commit, state: s }, { shop_name, product_id }) {
    const items = _.find(s[shop_name], {
      shop_name,
      product_id,
    });
    return api.thirdPartyShopWishlist.delete(items.id).then((response) => {
      if (response.status === 204) {
        commit(types.REMOVE_THIRD_PARTY_SHOP_WISHLIST_ITEM, items);
      }
    });
  },

};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_USER_TOKEN](s, response) {
    const expiresTime = Date.now() + (response.expires_in * 1000);
    s.token = response.token;
    s.expiresTime = expiresTime;
    // chrome.runtime.sendMessage({
    //   action: "okubuy-login",
    //   token: response.token,
    //   expiresTime: expiresTime
    // });
    document.cookie = 'token=' + response.token + "; " + expiresTime;
    // localStorage.setItem('token', response.token);
    // localStorage.setItem('expires-time', expiresTime);
  },
  [types.SET_TOKEN](s, token) {
    s.token = token;
  },
  [types.SET_EXPIRE_TIME](s, expireTime) {
    s.expiresTime = expireTime;
  },
  [types.REMOVE_TOKEN](s) {
    s.token = '';
    // chrome.runtime.sendMessage({
    //   action: "okubuy-logout",
    // });
    document.cookie = "token=; -1";
    localStorage.removeItem('token');
  },
  [types.REVEIVE_IDENTITY](s, data) {
    s.identity = data;
  },
  [types.RECEIVE_WISHLIST](s, data) {
    s.wishlist = [...data];
  },
  [types.ADD_TO_WISHLIST](s, data) {
    s.wishlist = [...s.wishlist, data];
  },
  [types.REMOVE_WISHLIST_ITEM](s, id) {
    s.wishlist = _.reject(s.wishlist, item => item.id === id);
  },
  [types.EMPTY_WISHLIST](s) {
    s.wishlist = [];
  },
  [types.RECEIVE_SHIPPING_ADDRESS](s, data) {
    s.shippingAddress = [...data];
  },
  [types.EMPTY_SHIPPING_ADDRESS](s) {
    s.shippingAddress = [];
  },
  [types.ADD_SHIPPING_ADDRESS](s, data) {
    s.shippingAddress = [...s.shippingAddress, data];
  },
  [types.UPDATE_SHIPPING_ADDRESS](s, { id, data }) {
    const index = _.findIndex(s.shippingAddress, { id });
    if (~index) {
      const newShippingAddress = [...s.shippingAddress];
      newShippingAddress[index] = data;
      s.shippingAddress = newShippingAddress;
    }
  },
  [types.DELETE_SHIPPING_ADDRESS](s, id) {
    s.shippingAddress = _.reject(s.shippingAddress, item => item.id === id);
  },
  [types.SET_DEFAULT_SHIPPING_ADDRESS](s, id) {
    _.each(s.shippingAddress, (item) => {
      item.default = item.id === id;
    });
  },
  [types.SET_SHIPPING_ADDRESS_DIALOG](s, val) {
    s.shippingAddressDialog = val;
  },
  [types.RECEIVE_DISTRICTS](s, data) {
    s.districts = [...data];
  },
  [types.RECEIVE_HISTORY](s, data) {
    s.history = data;
  },
  [types.NEW_HISTORY](s, data) {
    const today = moment().format('YYYY-MM-DD');
    if (!_.has(s.history, today)) {
      _.set(s.history, today, []);
    }
    s.history[today].push(data);
    sessionHistory.save(s.history);
  },
  [types.EMPRY_HISTORY](s) {
    s.history = null;
  },
  [types.RECEIVE_THIRD_PARTY_SHOP_WISHLIST](s, data) {
    let thirdPartyShopWishlist;
    _.forEach(data, (item) => {
      switch (item.shop_name) {
        case 'rakuten':
          thirdPartyShopWishlist = s.rakuten;
          break;
        case 'yahoo_jp':
          thirdPartyShopWishlist = s.yahoo_jp;
          break;
        case 'amazon_jp':
          thirdPartyShopWishlist = s.amazon_jp;
          break;
        default:
          throw Error('沒有該商店');
      }
      s[item.shop_name] = [...thirdPartyShopWishlist, item];
    });
  },
  [types.ADD_TO_THIRD_PARTY_WISHLIST](s, data) {
    let thirdPartyShopWishlist;
    switch (data.shop_name) {
      case 'rakuten':
        thirdPartyShopWishlist = s.rakuten;
        break;
      case 'yahoo_jp':
        thirdPartyShopWishlist = s.yahoo_jp;
        break;
      case 'amazon_jp':
        thirdPartyShopWishlist = s.amazon_jp;
        break;
      default:
        throw Error('沒有該商店');
    }
    s[data.shop_name] = [...thirdPartyShopWishlist, data];
  },
  [types.REMOVE_THIRD_PARTY_SHOP_WISHLIST_ITEM](s, items) {
    const { id, shop_name } = items;
    s[shop_name] = _.reject(s[shop_name], item => item.id === id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
